<template>
   <form @submit.prevent="$emit('zoom-to-location', formattedLocation())">
      <input 
         class="form-control form-control-sm"
         type="text"
         v-model="location"
         placeholder="Enter Pos(Eg: 85.43, 27.74)"
         required
         pattern="^\d+(\.\d*)?[eE]?,?\s*\d+(\.\d*)?[nN]?$"
      >
   </form>
</template>

<script>
export default {
   data()
   {
      return {
         location: ""
      }
   },
   methods: {
      formattedLocation()
      {
         const lnglatStr = this.location.includes(",") ? this.location.split(",") : this.location.split(" ");
         return lnglatStr.map(parseFloat);
      }
   }
}
</script>

<style scoped>
form {
   margin: 3px;
}
</style>